export default {
    install: (app) =>  {
        const deepState = new DeepState(app);
        app.provide('deepState', deepState);
    }
}

/**
 * class DeepState
 *
 * This is a helper class which allows people to set and get values in URL params without having to reload the
 * page. Originally this was going to be used in the
 */
export class DeepState {
    constructor () {
    }

    /**
     * Set the value for a key in the url, and set it without reloading the page
     * @param {String} key
     * @param {String} value
     */
    setState(key, value ) {
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set(key, value);
        history.replaceState({}, '', currentUrl.href)
    }

    /**
     * Get the state for a specific key from the url params.
     * @param {String} key
     * @returns The value in the URL or null
     */
    getState(key) {
        let currentParams = new URLSearchParams(document.location.search);
        return currentParams.get(key);
    }

    /**
     * Remove the given key/value pair from the URL parameters.
     * @param {String} key
     */
    removeState(key) {
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete(key)
        history.replaceState({}, '', currentUrl.href)
    }

    /**
     * Returns the query string for the "deep state"
     * @returns A string to save the state between URLs
     */
    stateString() {
        const currentParams = new URLSearchParams(document.location.search);
        return currentParams.toString();
    }

    /**
    * Clears all query parameters from the URL without reloading the page.
    * Used on Logout
    */
    clearAllStates() {
        let currentUrl = new URL(window.location.href);
        currentUrl.search = '';
        history.replaceState({}, '', currentUrl.href);
    }
}
